import { EHLegalPage } from '../components/EHLegalPage';
import { SEO } from '../components/SEO';

export default function TermsOfServicePage() {
  const metaDescription = 'Read our terms of service to understand how EveningHoney operates, the rules you need to follow, and what you can expect from our service.';

  return (
    <>
      <SEO
        title="Terms of Service"
        description={metaDescription}
        ogUrl="/legal/terms-of-service"
      />
      <EHLegalPage markdownPath="/legal/eh-terms-of-service.md" />
    </>
  );
}
